"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailReport = void 0;
require("./mail-report.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const mobx_1 = require("mobx");
const mail_header_1 = require("./components/mail-header");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const modal_1 = require("client/components/modal");
const number_formatter_1 = require("../claim-analytics/number-formatter");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/reporting/store");
const React = require("react");
let MailReport = class MailReport extends React.Component {
    constructor(props) {
        super(props);
        this.storeData = null;
        this.selectedRow = null;
        this.showQueryManager = true;
        this.query = {
            end: new Date(),
            start: new Date()
        };
        this.handleSubmit = async () => {
            this.showQueryManager = false;
            const result = await store_1.reportsStore.loadMailReport({ query: this.query });
            this.storeData.rowData = result.mailMessages;
        };
        this.renderMessageBody = () => {
            if (this.selectedRow) {
                const horror = (React.createElement("div", { dangerouslySetInnerHTML: { __html: this.selectedRow.MailMessage } }));
                const closeButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => {
                        this.selectedRow = null;
                    } }, "Close"));
                const modal = (React.createElement(modal_1.Modal, { buttons: [closeButton], onCancel: () => {
                        this.selectedRow = false;
                    }, width: "70%", height: "70%", top: "15%" },
                    React.createElement("div", { style: { margin: "1em" } },
                        React.createElement("span", null,
                            "Subject: ",
                            this.selectedRow.MailSubject),
                        React.createElement("br", null),
                        React.createElement("span", null,
                            "To: ",
                            this.selectedRow.MailToAddress)),
                    horror));
                return modal;
            }
        };
        this.renderQueryModal = () => {
            if (this.showQueryManager) {
                const cancelButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => {
                        this.showQueryManager = false;
                    } }, "Cancel"));
                const submitButton = (React.createElement(button_1.MaterialButton, { disabled: !this.query.start || !this.query.end, onClick: this.handleSubmit, primary: true }, "Submit"));
                const buttons = [submitButton, cancelButton];
                const modal = (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => {
                        this.showQueryManager = false;
                    } },
                    React.createElement("div", { style: { display: "flex" } },
                        this.genDate("start"),
                        this.genDate("end"))));
                return modal;
            }
        };
        // E-063
        this.onButtonExport = () => {
            const params = {
                fileName: "Mail Report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.onRowClicked = async (row) => {
            const { data } = row;
            const result = await store_1.reportsStore.loadMailMessage(data.MailID);
            this.selectedRow = result;
        };
        this.genDate = (type) => {
            const title = type.replace(/\b\w/g, c => c.toUpperCase());
            const jsx = (React.createElement("div", { style: { paddingRight: "1em" } },
                React.createElement("h3", null,
                    title,
                    " Date: "),
                React.createElement(date_picker_1.MaterialDatePicker, { label: `${title} Date`, required: true, value: this.query[type] || "", onChange: val => {
                        mobx_1.extendObservable(this.query, { [type]: val });
                    } }),
                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: new Date() });
                        }, style: { marginRight: "1em" } }, "Today"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: null });
                        } }, "Clear"))));
            return jsx;
        };
        this.storeData = {
            columnDefs: [
                {
                    enableRowGroup: true,
                    field: "MailFromAddress",
                    filter: "agTextColumnFilter",
                    headerCheckboxSelection: true,
                    headerName: "From"
                },
                {
                    field: "MailToAddress",
                    filter: "agTextColumnFilter",
                    headerName: "Sender"
                },
                {
                    field: "MailSubject",
                    filter: "agTextColumnFilter",
                    headerName: "Subject"
                },
                {
                    field: "MailSentDateTime",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        browserDatePicker: true,
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            return filterLocalDateAtMidnight.getTime() === cellDate.getTime()
                                ? 0
                                : cellDate < filterLocalDateAtMidnight
                                    ? -1
                                    : 1;
                        }
                    },
                    headerName: "Time Sent",
                    sort: "desc"
                },
                {
                    field: "MailSent",
                    filter: "agTextColumnFilter",
                    headerName: "Successfully Sent",
                    valueGetter: (params) => (params.data.MailSent ? "Y" : "N")
                }
            ],
            defaultColDef: {
                comparator: (a, b) => typeof a === "string"
                    ? a.localeCompare(b)
                    : a > b
                        ? 1
                        : a < b
                            ? -1
                            : 0,
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: []
        };
    }
    render() {
        const buttons = [
            React.createElement("button", { onClick: () => {
                    this.showQueryManager = true;
                }, style: { marginLeft: "2em" }, type: "button" }, "Manage Query")
        ];
        const header = React.createElement(mail_header_1.MailHeader, { buttons: buttons, title: "Mail Report" });
        // E-063
        // mail Log
        const agGrid = (React.createElement("div", { className: "ag-theme-balham", style: {
                height: "85%",
                width: "100%"
            } },
            React.createElement("button", { type: "button", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
            React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => {
                    this.storeData.gridApi = params.api;
                }, onRowClicked: this.onRowClicked, rowData: [...this.storeData.rowData], sideBar: true, suppressExcelExport: true, suppressRowClickSelection: true })));
        return (React.createElement(React.Fragment, null,
            header,
            React.createElement("br", null),
            agGrid,
            this.renderMessageBody(),
            this.renderQueryModal()));
    }
};
__decorate([
    mobx_1.observable
], MailReport.prototype, "storeData", void 0);
__decorate([
    mobx_1.observable
], MailReport.prototype, "selectedRow", void 0);
__decorate([
    mobx_1.observable
], MailReport.prototype, "showQueryManager", void 0);
__decorate([
    mobx_1.observable
], MailReport.prototype, "query", void 0);
MailReport = __decorate([
    mobx_react_1.observer
], MailReport);
exports.MailReport = MailReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/mail-report/mail-report.tsx
// module id = 3973
// module chunks = 0